import React, { useState , forwardRef } from "react";
import { MaintanceSelector } from "../shared/Selectors.js";
import DatePicker from "react-datepicker";
import { toUTCString } from '../../utils.js'
import FileUploaderModal from '../shared/FileUploaderModal.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faImage, faFileUpload } from '@fortawesome/free-solid-svg-icons';

const DateTimeInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
      className="form-control"
      value={value}
      onChange={onChange}
      onClick={onClick}
      ref={ref}
    />
  ));


export default function MaintanceForm({ sensor, save,isLoading}) {
  const [comments, setComments] = useState("");
  const [type, setType] = useState ("maintance");
  const [maintanceTypeId, setMaintanceTypeId] = useState("")
  const [startsAt, setStartsAt] = useState("")
  const [files, setFiles] = useState([])
  const [showFileUploader, setShowFileUploader] = useState(false)

  const [errors, setErrors] = useState({});

  const validations = [];

  const handleValidateFiles = (files) => {
    const validImageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp']
    const validVideoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv', '.3gp', '.flv']
    const validExtensions = [...validImageExtensions, ...validVideoExtensions]

    const invalidFiles = files.filter(file => {
      if (!file || !file.name) {
        return true
      }
      const extension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'))
      return !validExtensions.includes(extension)
    })

    if (invalidFiles.length > 0) {
      return false
    }

    return true
  }

  const handleFileUploadSuccess = (uploadedFiles) => {
    setFiles(prevFiles => [...prevFiles, ...uploadedFiles])
    setShowFileUploader(false)
  }

  const handleRemoveFile = (fileId) => {
    setFiles(prevFiles => prevFiles.filter(file => file.id !== fileId))
  }

  function validate(e) {
    e.preventDefault();

    if (!comments) {
      validations.push(["comments", "Comentario es requerido"]);
    }

    if (!maintanceTypeId){
        validations.push(["maintaceType", "Tipo de mantenimiento es requerido"]);
    }

    if( !startsAt){
        validations.push(["startsAt", "Fecha es requerida"]);
    }


    if (validations.length) {
      setErrors(
        validations.reduce((acc, item) => ({ ...acc, [item[0]]: item[1] }), {})
      );
      return;
    } else {
      setErrors([]);
    }

    const payload = {
      comments,
      type,
      report_type_id: maintanceTypeId,
      created_at: toUTCString(startsAt)
    }

    // Agregar archivos (imágenes/videos) si existen
    if (files.length > 0) {
      payload.images = files.map(x => ({
        file_key: x.file_key,
        mime_type: x.type
      }))
    }

    save(payload);
  }

  return (
    <form onSubmit={validate}>
      <div className="form-group">
        <label className="font-weight-bold d-block">Fecha de la mantención</label>
        <DatePicker
          selected={startsAt}
          onChange={(date) => setStartsAt(date)}
          selectsStart
          startDate={startsAt}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={10}
          dateFormat="dd/MM/yyyy HH:mm"
          customInput={<DateTimeInput />}
        />
        <div className="invalid-feedback">{errors.startsAt}</div>
      </div>

      <div className="form-group">
        <label className="font-weight-bold">Mantenimiento</label>
        <MaintanceSelector
          placeholder="Seleccione una tipo de mantenimiento"
          onChange={(value) => setMaintanceTypeId(value)}
          defaultValue={maintanceTypeId}
          disabled={isLoading}
          hasError={!!errors.maintaceType}
        />
        <div className="invalid-feedback">{errors.maintaceType}</div>
      </div>

      <div className="form-group">
        <label className="font-weight-bold">Comentarios</label>
        <textarea
          rows={4}
          className={`form-control ${errors.comments ? "is-invalid" : ""}`}
          onChange={(e) => setComments(e.target.value)}
          value={comments}
          disabled={isLoading}
          autoFocus={true}
          maxLength={255}
        />
        <div className="d-flex justify-content-between">
          <div className="invalid-feedback">{errors.comments}</div>
          <small className="text-muted">{comments.length}/255 caracteres</small>
        </div>
      </div>

      <div className="form-group">
        <label className="font-weight-bold">Archivos multimedia</label>
        <div className="mb-2">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => setShowFileUploader(true)}
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faFileUpload} className="mr-2" />
            Agregar imágenes o videos
          </button>
        </div>

        {files.length > 0 && (
          <div className="row">
            {files.map((file, index) => (
              <div key={file.id} className="col-6 col-md-4 mb-3">
                <div className="card">
                  <div className="card-body p-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-truncate" style={{ fontSize: '0.85em' }}>
                        <FontAwesomeIcon icon={faFileUpload} className="mr-1 text-muted" />
                        {file.name}
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger ml-2"
                        onClick={() => handleRemoveFile(file.id)}
                        disabled={isLoading}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {files.length === 0 && (
          <p className="text-muted" style={{ fontSize: '0.9em' }}>
            No se han agregado archivos
          </p>
        )}
      </div>

      <div className="form-group">
        <button
          className={`btn btn-primary ${isLoading ? "loading" : ""}`}
          disabled={isLoading}
        >
          <span>Guardar</span>
          <div className="spinner-border" role="status"></div>
        </button>
      </div>

      {showFileUploader && (
        <FileUploaderModal
          title="Subir archivos multimedia"
          description="Sube imágenes (JPG, PNG, GIF, WEBP) o videos (MP4, MOV, AVI, WEBM, MKV, 3GP, FLV) del mantenimiento"
          onClose={() => setShowFileUploader(false)}
          onSuccess={handleFileUploadSuccess}
          onValidateFiles={handleValidateFiles}
        />
      )}
    </form>
  );
}
